import React from 'react'

function Ropa({...r}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" {...r}>
      <path
        fill="#126FFF"
        d="M32.81 42.12l1.69 3.42 3.77.55-2.73 2.66.65 3.75-3.38-1.77-3.37 1.77.65-3.75-2.73-2.66 3.77-.55 1.68-3.42z"
      ></path>
      <path
        stroke="#00033A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M37.08 22.06l24.21 11.11c.78.3 1.31 1.06 1.31 1.9 0 1.12-.91 2.04-2.04 2.04H46.05"
      ></path>
      <path
        stroke="#126FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M21.91 44.55v11.91c0 2.46 2 4.47 4.47 4.47h11.91c2.46 0 4.47-2 4.47-4.47V41.32c0-1.19-.46-2.32-1.31-3.16l-5.52-5.52c-1.92-1.92-5.27-1.92-7.19 0l-4.19 4.19"
      ></path>
      <path
        stroke="#00033A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M31.16 37.11H4.01c-.82 0-1.62-.44-1.96-1.19-.51-1.13.08-2.35 1.13-2.75l29-11.05c.58-.22.96-.77.96-1.39v-2.05c0-1.33.73-2.62 2-3.54 2.06-1.49 2.96-4.09 2.21-6.61-.52-1.76-1.89-3.22-3.62-3.82-2.06-.72-4.29-.31-5.9 1.04a5.962 5.962 0 00-2.13 4.56"
      ></path>
    </svg>
  )
}

export default Ropa